//
//
//
//
//
//
//
//
//
//
//
import ItemListN from "./itemListComp/ItemListN.vue";
import goodsList from "./itemListComp/goodsList.vue";
export default {
  name: "ItemList",
  components: {
    ItemListN: ItemListN,
    goodsList: goodsList
  },
  mixins: [],
  data: function data() {
    return {
      activeIndex: 'ItemListN'
    };
  },
  created: function created() {},
  activated: function activated() {},
  methods: {
    handover: function handover(index) {
      this.activeIndex = index;
    }
  }
};